export interface FormGroupItem {
    id?: number;
    idGrupo_aux?: number;
    formulario_id?: number;

    titulo?: string;
    visibilidade?: 'visivel' | 'condicional';
    campo_formulario_id?: FormGroupItem;
    estrutura?: FormField[];

    gatilhos?: Trigger[];
    gatilhos_condicionais?: Trigger[];
}

export interface FormField {
    id?: number;
    nome?: string;
    tipo?: FormItemType;
    itens?: string[];
    itens_filter?: string[];
    valor_principal?: string;
    valor_secundario?: string;
    texto_associado?: string;
    opcional?: boolean;
    cond_item?: string;
    valores_com_inconsistencia?: string[];
    conditional?: FormGroupItem;
    ativaCondicional?: boolean;
}

export class Trigger {
    id?: number;
    campo_formulario_id?: number;
    gatilho_campo_formulario_id?: number;
    gatilho_campo_ordem?: number;
    gatilho_regra?: TriggerRule;
    idGrupo_aux: number;
    idCampo: number;
    itemGatilho: boolean;
}

export class TriggerRule {
    valor: any;
}

export enum FormItemType {
    GROUP = 'grupo',
    CONDITIONAL_GROUP = 'grupoCond',
    TEXT = 'texto',
    TEXT_AREA = 'textArea',
    LIST_FIXED = 'listaFixa',
    LIST_MULTIPLE = 'listaMultipla',
    NUMBER = 'numero',
    BOOLEAN = 'verdadeiroFalso',
    MULTI_MEDIA_PDF = 'pdf',
    MULTI_MEDIA_IMAGE = 'foto',
    MULTI_MEDIA_VIDEO = 'video',
    DATE_TIME = 'dataHora',
    GPS = 'gps',
    SIGNATURE = 'assinaturaFormulario',
    DATA_SYSTEM = 'dadosSistema',
}

export const FORM_ITEM_PROPS: { [key: string]: { name: string, icon: string } } = {
    [FormItemType.GROUP]: {
        name: 'Grupo de Campos',
        icon: 'la la-layer-group'
    },
    [FormItemType.CONDITIONAL_GROUP]: {
        name: 'Grupo Condicional',
        icon: 'la la-sitemap'
    },
    [FormItemType.TEXT]: {
        name: 'Texto',
        icon: 'la la-font'
    },
    [FormItemType.TEXT_AREA]: {
        name: 'Área de Texto',
        icon: 'la la-paragraph'
    },
    [FormItemType.LIST_FIXED]: {
        name: 'Lista Fixa',
        icon: 'la la-list'
    },
    [FormItemType.LIST_MULTIPLE]: {
        name: 'Lista Múltipla',
        icon: 'la la-check-square'
    },
    [FormItemType.NUMBER]: {
        name: 'Número',
        icon: 'la la-hashtag'
    },
    [FormItemType.BOOLEAN]: {
        name: 'Verdadeiro/Falso',
        icon: 'la la-toggle-on'
    },
    [FormItemType.MULTI_MEDIA_PDF]: {
        name: 'PDF',
        icon: 'la la-file-pdf'
    },
    [FormItemType.MULTI_MEDIA_IMAGE]: {
        name: 'Imagem',
        icon: 'la la-image'
    },
    [FormItemType.MULTI_MEDIA_VIDEO]: {
        name: 'Vídeo',
        icon: 'la la-video'
    },

    /*[FormItemType.DATA_SYSTEM]: {
        name: 'Dados do Sistema',
        icon: 'la la-database'
    },*/
    [FormItemType.GPS]: {
        name: 'GPS',
        icon: 'la la-map-marker'
    },
    [FormItemType.DATE_TIME]: {
        name: 'Data/Hora',
        icon: 'la la-calendar'
    },
    [FormItemType.SIGNATURE]: {
        name: 'Assinatura',
        icon: 'la la-signature'
    },
}

export const FORM_GROUP_TEMPLATE: { [key: string]: FormGroupItem } = {
    [FormItemType.GROUP]: {
        titulo: "Grupo de campos",
        visibilidade: "visivel",
        estrutura: [] as FormField[],
    },
    [FormItemType.CONDITIONAL_GROUP]: {
        titulo: "Grupo condicional",
        visibilidade: "condicional",
        estrutura: [] as FormField[],
        gatilhos: [] as Trigger[],
        gatilhos_condicionais: [] as Trigger[],
    },
}

export const FORM_FIELD_TEMPLATE: { [key: string]: FormField } = {
    [FormItemType.TEXT]: {
        tipo: FormItemType.TEXT,
        nome: "Texto",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.TEXT_AREA]: {
        tipo: FormItemType.TEXT_AREA,
        nome: "Área de texto",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.LIST_FIXED]: {
        tipo: FormItemType.LIST_FIXED,
        nome: "Lista Fixa",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.LIST_MULTIPLE]: {
        tipo: FormItemType.LIST_MULTIPLE,
        nome: "Lista Múltipla",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.NUMBER]: {
        tipo: FormItemType.NUMBER,
        nome: "Número",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.BOOLEAN]: {
        tipo: FormItemType.BOOLEAN,
        nome: "Verdadeiro/falso",
        texto_associado: "",
        valor_principal: "SIM",
        valor_secundario: "NAO",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.MULTI_MEDIA_PDF]: {
        tipo: FormItemType.MULTI_MEDIA_PDF,
        nome: 'PDF',
        texto_associado: '',
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.MULTI_MEDIA_IMAGE]: {
        tipo: FormItemType.MULTI_MEDIA_IMAGE,
        nome: 'Imagem',
        texto_associado: '',
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.MULTI_MEDIA_VIDEO]: {
        tipo: FormItemType.MULTI_MEDIA_VIDEO,
        nome: 'Vídeo',
        texto_associado: '',
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.DATE_TIME]: {
        tipo: FormItemType.DATE_TIME,
        nome: "Data/hora",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.GPS]: {
        tipo: FormItemType.GPS,
        nome: "GPS",
        texto_associado: "",
        itens: [] as string[],
        opcional: false,
    },
    [FormItemType.SIGNATURE]: {
        tipo: FormItemType.SIGNATURE,
        nome: 'Assinatura',
        texto_associado: '',
        itens: [] as string[],
        opcional: false,
    },
    /*[FormItemType.DATA_SYSTEM]: {
        tipo: FormItemType.DATA_SYSTEM,
        nome: "Dados do sistema",
        texto_associado: "",
        itens: [] as string[],
        opcional: false
    }*/
};
